<div class="button-widget" [ngClass]="getWidgetClasses()">
  <a [routerLink]="getUrl()" [ngClass]="getClasses()">{{widget.data.text}}</a>
</div>
